export default __webpack_public_path__ + "static/media/qPay.a327c7a2.svg";